
export const deleteTaskText = {
  deletable: {
    title: 'Aufgabe löschen',
    text: 'Möchten Sie diese Aufgabe wirklich löschen?'
  },
  endable: {
    title: 'Diese Aufgabe ab Heute beenden?',
    text: 'Vergangene Einheiten dieser Aufgabe bleiben dabei unverändert.'
  }
}



// WEBPACK FOOTER //
// ./src/constants/modalTexts.js